import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons"; // Example icon
import { FormInput, UnderlineLink } from "../../components/";

const helpLinks = [
  { text: "How to connect broker in Qunattrix?", href: "#" },
  { text: "How to create account in Dhan?", href: "#" },
];

function DhanConnection() {
  return (
    <div className="flex overflow-hidden flex-col bg-white" role="main">
      <div className="flex flex-wrap gap-6 items-start mt-6 w-full max-md:max-w-full">
        <main className="flex flex-col grow shrink pb-10 rounded-xl min-w-[240px] w-[1146px] max-md:max-w-full">
          <div className="flex flex-col w-full max-w-[1160px] max-md:max-w-full">
            <div className="flex gap-1 items-center self-start text-xl font-semibold text-gray-600">
              <img
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/eaf456ca9e05dd124e64a22605730fc2f808f0d5f44f12edf93fd92f835dd5f8?placeholderIfAbsent=true&apiKey=aad7a7097547481c93a386421ef45bec"
                className="object-contain shrink-0 self-stretch my-auto w-6 aspect-square"
                alt=""
              />
              <h1 className="self-stretch my-auto">Dhan Connection</h1>
            </div>
            <p className="mt-1 text-sm leading-none text-gray-500">
              Trade can check and know about the stocks sector wise
            </p>
          </div>

          <form className="flex flex-col items-start mt-6 w-full max-md:max-w-full">
            <div className="flex flex-wrap gap-4 items-end font-medium text-gray-500 max-md:max-w-full">
              <FormInput label="Token" value="12894003" />
              <FormInput label="Client ID" value="009450" />
              <button className="gap-1 self-stretch px-3 py-3 text-sm text-center whitespace-nowrap rounded-3xl bg-zinc-400 min-h-[40px] min-w-[60px] text-neutral-50 w-[120px]">
                Connect
              </button>
            </div>

            <label className="flex gap-2 items-center mt-2 cursor-pointer">
              <input type="checkbox" className="sr-only" />
              <div className="flex justify-center items-center self-stretch my-auto w-4">
                <FontAwesomeIcon
                  icon={faCheckCircle}
                  className="text-gray-500"
                />
              </div>
              <span className="self-stretch my-auto text-sm font-medium text-gray-500">
                Auto login this account
              </span>
            </label>

            <div className="flex gap-1 justify-center items-center px-7 mt-6 max-w-full text-xs text-center whitespace-nowrap text-zinc-500 w-[351px] max-md:px-5">
              <div className="flex-1 shrink self-stretch my-auto h-px border border-gray-200 border-solid basis-0 w-[139px]" />
              <div className="self-stretch my-auto">Or</div>
              <div className="flex-1 shrink self-stretch my-auto h-px border border-gray-200 border-solid basis-0 w-[139px]" />
            </div>

            <button className="flex gap-1 justify-center items-center px-3 py-3 mt-6 text-sm font-medium text-center text-gray-500 rounded-3xl bg-zinc-100 min-h-[40px] min-w-[60px]">
              <img
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/b191924930a2e1d0c4ac0444b5de67a0b630dcf86cea4b1788ce3c1b325b0d9f?placeholderIfAbsent=true&apiKey=aad7a7097547481c93a386421ef45bec"
                className="object-contain shrink-0 self-stretch my-auto w-4 aspect-square"
                alt=""
              />
              <span className="self-stretch my-auto">Connect with Dhan</span>
            </button>

            <div className="flex flex-col mt-6 text-sm font-medium text-center text-neutral-600">
              {helpLinks.map((link, index) => (
                <UnderlineLink key={index} text={link.text} href={link.href} />
              ))}
            </div>
          </form>
        </main>
      </div>
    </div>
  );
}

export default DhanConnection;
